/**
 * DR-4850: parser, metadata, embeddings, and classification can fail after
 * every page for that stage is already done. Data extraction keeps its page
 * verdict on purpose. Pages and reconstruction already paint their own error.
 */
const STAGE_ERROR_HIDES_FULL_SUCCESS = new Set([
  'pdf-parser',
  'metadata',
  'embeddings',
  'classification',
]);

export function hidesFullSuccessOnStageError(step: string): boolean {
  return STAGE_ERROR_HIDES_FULL_SUCCESS.has(step);
}
